import { render, staticRenderFns } from "./OrderShopItem.vue?vue&type=template&id=98f1c4bc&"
import script from "./OrderShopItem.vue?vue&type=script&lang=js&"
export * from "./OrderShopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports